import React, { useEffect, useState, useRef } from "react";
import {
  ContentFilters,
  ContentHeaderMySpace,
  GeneralMySpaces,
  TitleMySpace,
  useStyles,
} from "./MySpacesContainer.styled";
import GeneralFiltersContainer from "../GeneralFiltersContainer/GeneralFiltersContainer";
import MySpaces from "../../components/MySpaces/MySpaces";
import { Col, Row } from "react-bootstrap";
import { useLazyQuery } from "@apollo/client";
import { ALL_MY_SPACES } from "../../GraphQL/Queries";
import { clientWellness } from "../../App";
import { useLocation, useHistory } from "react-router-dom";
import SearchComponent from "../../components/SearchComponent/SearchComponent";

const MySpacesContainer = () => {
  const classes = useStyles();
  const history = useHistory();
  const [filtered, setFiltered] = useState(false);
  const [dataFilter, setDataFilter] = useState({});
  const [rowsPerPage] = useState(10);
  const [myspaces, setMySpaces] = useState([]);
  const filtersViews = {
    initialDate: true,
    finalDate: true,
    search: {
      show: false,
      label: "Search by name",
    },
  };

  const [, setTopBannerConfig] = useState();
  const location = useLocation();
  const [searchText, setSearchText] = useState();
  const rSearch = useRef();

  const getDataBySearch = () => {
    setSearchText(rSearch?.current?.value);
  };

  const applySearchOnBreak = () => {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(() => {
        getDataBySearch();
      }, 500);
    };
  };

  const handleSearch = applySearchOnBreak();

  useEffect(() => {
    filterMySpaces();
  }, [searchText]);

  useEffect(() => {
    if (location?.topBanner) {
      let config = JSON.parse(location.topBanner);
      setTopBannerConfig(config);
    }
  }, [location]);

  const [
    runQueryAllMySpaces,
    { loading: loadingMySpacesFirst, error: errorMySpacesFirst },
  ] = useLazyQuery(ALL_MY_SPACES, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setMySpaces(data?.allMySpaces);
    },
  });

  useEffect(() => {
    if (!filtered) {
      runQueryAllMySpaces({
        variables: {
          startDate: null,
          finishDate: null,
          searchBy: "",
        },
      });
    }
  }, [filtered]);

  let filterMySpaces = () => {
    setFiltered(true);
    runQueryAllMySpaces({
      variables: {
        startDate: dataFilter.initialDate ? dataFilter.initialDate : null,
        finishDate: dataFilter.finalDate ? dataFilter.finalDate : null,
        searchBy: searchText ? searchText : "",
      },
    });
  };

  let goToDetail = (myspace) => {
    setTimeout(() => {
      history.push({ pathname: "/DetailSpace", state: { url: myspace.url } });
    }, 0);
  };

  return (
    <GeneralMySpaces>
      <Row className={classes.contentForMySpaces}>
        <Col md={12} style={{ marginLeft: "1.5em" }} className={"mt-5 mb-3"}>
          <ContentHeaderMySpace>
            <TitleMySpace>My Spaces</TitleMySpace>{" "}
            <ContentFilters className={"mr-0 mb-3"}>
              <GeneralFiltersContainer
                filtersViews={filtersViews}
                FilterEvents={filterMySpaces}
                setDataFilter={setDataFilter}
                filtered={filtered}
                setFiltered={setFiltered}
              />
              <SearchComponent
                rSearch={rSearch}
                handleSearch={handleSearch}
                setSearchText={setSearchText}
              />
            </ContentFilters>
          </ContentHeaderMySpace>
        </Col>
        <Row>
          <Col md={12}>
            <MySpaces
              loadingMySpacesFirst={loadingMySpacesFirst}
              errorMySpacesFirst={errorMySpacesFirst}
              myspaces={myspaces}
              rowsPerPage={rowsPerPage}
              goToDetail={goToDetail}
            />
          </Col>
        </Row>
      </Row>
    </GeneralMySpaces>
  );
};

export default MySpacesContainer;
